export const GET_MASTER_OPTIONS = 'GET_MASTER_OPTIONS';
export const GET_MASTER_ALL_OPTIONS = 'GET_MASTER_ALL_OPTIONS';
export const MASTER_OPTIONS_REQUEST = 'MASTER_OPTIONS_REQUEST';
export const MASTER_OPTIONS_REQUEST_FAILURE = 'MASTER_OPTIONS_REQUEST_FAILURE';
export const SET_ADD_MASTER_IN_OPTIONS = 'SET_ADD_MASTER_IN_OPTIONS';
export const SET_UPDATE_MASTER_IN_OPTIONS = 'SET_UPDATE_MASTER_IN_OPTIONS';
export const SET_ACCOUNTS_DATA_IN_OPTIONS = 'SET_ACCOUNTS_DATA_IN_OPTIONS';
export const SET_RELOAD_MASTER_PAYLOAD = 'SET_RELOAD_MASTER_PAYLOAD';
export const UPDATE_ACCOUNT_IN_MASTER_OPTIONS = 'UPDATE_ACCOUNT_IN_MASTER_OPTIONS';
export const ADD_ACCOUNT_IN_MASTER_OPTIONS = 'ADD_ACCOUNT_IN_MASTER_OPTIONS';
export const DELETE_ACCOUNT_IN_MASTER_OPTIONS = 'DELETE_ACCOUNT_IN_MASTER_OPTIONS';
export const UPDATE_BOOK_IN_MASTER_OPTIONS = 'UPDATE_BOOK_IN_MASTER_OPTIONS';
export const ADD_BOOK_IN_MASTER_OPTIONS = 'ADD_BOOK_IN_MASTER_OPTIONS';
export const DELETE_BOOK_IN_MASTER_OPTIONS = 'DELETE_BOOK_IN_MASTER_OPTIONS';
export const UPDATE_ITEM_IN_MASTER_OPTIONS = 'UPDATE_ITEM_IN_MASTER_OPTIONS';
export const ADD_ITEM_IN_MASTER_OPTIONS = 'ADD_ITEM_IN_MASTER_OPTIONS';
export const DELETE_ITEM_IN_MASTER_OPTIONS = 'DELETE_ITEM_IN_MASTER_OPTIONS';